
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="10"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品类目">
							<c-select name="category_id" async @search="searchCategory"  v-model="categoryId"></c-select>
						</m-search-item>
						<m-search-item label="品牌">
							<c-select name="brand_id" async @search="searchBrand" v-model="brandId"></c-select>
						</m-search-item>
						<m-search-item label="型号">
							<c-select name="model_id" async @search="searchModel"></c-select>
						</m-search-item>
						<m-search-item label="等级">
							<c-select name="level_type" :options="levelTypeOptions"></c-select>
						</m-search-item>
						<m-search-item label="是否质检">
							<c-select name="is_quality_check" :options="qualityCheckOptions"></c-select>
						</m-search-item>
						<m-search-item label="推送渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="操作时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_product_list_shelf')" color="main" prepend-icon="tf-shelf" @click="shelfProduct">批量上架</c-button>
					<c-button v-if="auth('b_product_list_offshelf')" color="red" :hollow="true" prepend-icon="tf-offshelf" @click="batchOffShelf">批量下架</c-button>
					<c-button v-if="hasHandover && auth('b_product_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock()">批量返库</c-button>
					<c-button v-if="hasHandover && auth('b_product_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer()">批量调拨</c-button>
                    <c-button v-if="hasHandover && auth('b_sales_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject()">批量同意驳回</c-button>
					<c-button v-if="auth('b_offline_order_create') && saasInfo.is_offline_order > 0" prepend-icon="tf-settle-account" @click="offlineSell()">批量线下售出</c-button>
					<c-button v-if="auth('b_loan_list_create')" prepend-icon="tf-add" @click="lendOut()">批量借出</c-button>
					<c-dropdown>
						<c-button prepend-icon="tf-change-price">改价</c-button>

						<template #menu>
							<c-menu-list>
								<c-menu-item v-if="auth('b_product_list_price_edit')" icon="tf-change-price" @click="editPrice">批量改价</c-menu-item>
								<c-menu-item v-if="auth('b_product_list_price_edit')" icon="tf-import" @click="importPrice">导入改价</c-menu-item>
							</c-menu-list>
						</template>
					</c-dropdown>
					<c-button v-if="auth('b_product_list_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<span class="m-ratio-tip">
						控价比例：{{priceRatio === null ? '未设置' : priceRatio + '%'}}
						<i class="tf-edit tf" @click="editPriceRatio"></i>
					</span>
					<span class="m-age-legend">
						库龄颜色
						<c-tooltip color="white">
							<span class="m-legend-help">?</span>
							<template #tip>
								<p v-for="(item, i) in stockAgeColors" :key="i" class="m-legend-item">
									<i class="m-legend-block" :style="{background: item.color}"></i>
									<span>{{item.label}}</span>
								</p>
							</template>
						</c-tooltip>
					</span>
				</template>

				<template #batchOperate="{data}">
                    <c-button v-if="auth('b_product_list_shelf')" color="main" prepend-icon="tf-shelf" @click="shelfProduct">批量上架</c-button>
                    <c-button v-if="auth('b_product_list_offshelf')" color="red" :hollow="true" prepend-icon="tf-offshelf" @click="batchOffShelf">批量下架</c-button>
                    <c-button v-if="hasHandover && auth('b_product_list_transfer')" prepend-icon="tf-transfer" @click="openTransfer(data)">批量调拨</c-button>
					<c-button v-if="hasHandover && auth('b_product_list_return')" prepend-icon="tf-return-stock" @click="batchReturnToStock(data)">批量返库</c-button>
                    <c-button v-if="hasHandover && auth('b_sales_handover_confirm_reject')" prepend-icon="tf-batch" @click="confirmReject(data)">批量同意驳回</c-button>
					<c-button v-if="auth('b_offline_order_create') && saasInfo.is_offline_order > 0" prepend-icon="tf-settle-account" @click="offlineSell(data)">批量线下售出</c-button>
					<c-button v-if="auth('b_loan_list_create')" prepend-icon="tf-add" @click="lendOut(data)">批量借出</c-button>
					<!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
					<c-button v-if="auth('b_product_list_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <span class="m-ratio-tip">
						控价比例：{{priceRatio === null ? '未设置' : priceRatio + '%'}}
						<i class="tf-edit tf" @click="editPriceRatio"></i>
					</span>
                    <span class="m-age-legend">
						库龄颜色
						<c-tooltip color="white">
							<span class="m-legend-help">?</span>
							<template #tip>
								<p v-for="(item, i) in stockAgeColors" :key="i" class="m-legend-item">
									<i class="m-legend-block" :style="{background: item.color}"></i>
									<span>{{item.label}}</span>
								</p>
							</template>
						</c-tooltip>
					</span>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_product_list_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #condition_info="{data}">
					<div class="m-condition">
						<p v-for="(item, i) in getConditionList(data)" :key="i">{{item}}</p>
					</div>
				</template>

				<template #overall_state="{data}">
                    <span v-if="sourceHandoverStateText(data)" :style="{color: isSourceRejectPending(data) ? '#e53e3e' : ''}">{{sourceHandoverStateText(data)}}</span>
                    <!--是否展示销售主状态由服务端按版本能力下发（旗舰版要已接驳到销售区、门店版在库即看销售进度），端内不再硬编 state==32-->
                    <template v-else-if="data.show_sale_state">
                        <c-state dict="saleOverallStateDic" :value="data.overall_state"></c-state>
                    </template>
                    <!--处在其他状态，展示主状态-->
                    <template v-else>
                        <c-state dict="productStateDic" :value="data.state"></c-state>
                    </template>
				</template>

				<template #price_info="{data}">
					<div class="m-price-info">
						<p>成本价：{{formatPrice(data.cost_price)}}</p>
						<p v-for="(item, i) in data.reference_price_list || []" :key="i">
							{{item.platform_name}}参考价：{{formatPrice(item.sale_price)}}
						</p>
					</div>
				</template>

				<template #b_report_state="{data}">
					<i v-if="data.b_report_state" class="tf-check tf" :class="qualityReportClass(data.b_report_state)"></i>
				</template>

				<template #c_report_state="{data}">
					<i v-if="data.c_report_state" class="tf-check tf" :class="qualityReportClass(data.c_report_state)"></i>
				</template>

				<template #channel_list="{data}">
					<div v-if="(data.channel_list || []).length" class="m-channel-lines">
						<p v-for="(channel, i) in data.channel_list" :key="i" class="flex">
							<span>{{channel.channel_name}}：<span class="red">{{formatPrice(channel.sale_price)}}</span></span>
							<!-- 服务端未下发 min_price（未维护控价比例）时标记 -->
							<i v-if="auth('b_product_list_price_edit') && data.buttons?.edit_price?.visible && canEditPrice(channel)" class="tf-edit tf m-channel-edit" @click="editChannelPrice(data, channel)"></i>
							<c-tooltip v-if="channelStateText(channel).tip" :tip="channelStateText(channel).tip">
								<span :class="channelStateText(channel).cls">
									{{channelStateText(channel).text}}
								</span>
                                <span class="m-channel-tip">!</span>
								<template #tip>
									<p>{{channelStateText(channel).tip}}</p>
								</template>
							</c-tooltip>
							<span v-else :class="channelStateText(channel).cls">
								{{channelStateText(channel).text}}
							</span>
						</p>
					</div>
					<span v-else>-</span>
				</template>

				<template #is_dismantle="{data}">
					<span v-if="data.is_dismantle==1" class="m-dismantle-tag" title="已拆机">拆</span>
					<span v-else>-</span>
				</template>
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>

				<!--演示机开关：待上架/已下架状态可操作（已放开接驳人本人限制），其余只读展示-->
				<template #is_demo="{data}">
					<c-switch v-if="canEditDemo(data)" v-model="data.is_demo" :state-value="[1, 2]" :state-text="['是','否']" @beforeChange="demoHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="yesOrNoOptions" :value="data.is_demo"></c-state>
				</template>

				<!--是否借出：借出为虚拟状态不改条码/商品字段，服务端按借出台账未归还明细判定为 1-是 2-否-->
				<template #is_lend="{data}">
					<c-state dict="yesOrNoOptions" :value="data.is_lend"></c-state>
				</template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>
                <template #retail_price="{data}">
                    {{formatPrice(data.retail_price)}}
                </template>
                <template #repair_cost="{data}">
                    {{formatPrice(data.repair_cost)}}
                </template>

                <template #stock_days="{data}">
					<span :style="{color: stockAgeColor(data.stock_days)}">{{formatDay(data.stock_days)}}</span>
				</template>

				<template #transit_days="{data}">
					<span :style="{color: data.transit_days > 2 ? '#e53e3e' : ''}">{{formatDay(data.transit_days)}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<!--行级按钮可见性由服务端按版本能力+商品/条码/渠道状态计算下发（data.buttons），端内只保留 auth 权限点位判断，不再写 isOnSale/state==32/overall_state 硬编-->
						<c-table-button v-if="auth('b_product_list_shelf') && data.buttons?.shelf?.visible" icon="tf-shelf" @click="openShelfChannel(data)">上架</c-table-button>
						<c-table-button v-if="auth('b_product_list_offshelf') && data.buttons?.offshelf?.visible" icon="tf-offshelf" @click="offShelf([data])">下架</c-table-button>
						<c-table-button v-if="auth('b_product_list_transfer') && data.buttons?.transfer?.visible" icon="tf-transfer" @click="rowTransfer(data)">调拨</c-table-button>
						<c-table-button v-if="auth('b_product_list_return') && data.buttons?.return_to_stock?.visible" icon="tf-return-stock" @click="batchReturnToStock([data])">返库</c-table-button>
                        <c-table-button v-if="auth('b_sales_handover_confirm_reject') && data.buttons?.confirm_reject?.visible" icon="tf-accept" @click="confirmReject(data)">同意驳回</c-table-button>
						<c-table-button v-if="auth('b_offline_order_create') && saasInfo.is_offline_order > 0 && data.buttons?.offline_sell?.visible"  icon="tf-settle-account" @click="offlineSell([data])">线下售出</c-table-button>
						<c-table-button v-if="auth('b_loan_list_create')  && data.buttons?.lend?.visible" icon="tf-add" @click="lendOut([data])">借出</c-table-button>

                        <c-table-button v-if="auth('b_product_list_price_edit') && data.buttons?.view_price_log?.visible" icon="tf-detail" @click="viewPriceLog(data)">改价记录</c-table-button>
                        <c-table-button v-if="auth('b_product_list_push_log') && data.buttons?.view_push_log?.visible" icon="tf-detail" @click="viewPushLog(data)">推送记录</c-table-button>
                        <c-table-button v-if="auth('b_product_list_loan_log') && data.buttons?.view_lend_log?.visible" icon="tf-detail" @click="viewLendLog(data)">借出记录</c-table-button>
                        <c-table-button v-if="auth('b_product_list_quality_report') && data.buttons?.view_quality_report?.visible" icon="tf-detail" @click="viewQualityReport(data)">质检报告</c-table-button>
                        <!-- 本页不挂质检/维修作业入口：功能入口维持现状，H5 没有的页面也不在这里补 -->
                        <!-- 质检/维修作业在质检列表 / 维修列表页完成（两页的查询已按版本分流） -->
					</template>
				</c-table-column>
			</view-list>
			<!--调拨弹窗（销售中直调：目标质检/维修/销售）-->
			<code-transfer ref="codeTransfer" :allow-states="[32]" dialog-title="销售调拨" @resolve="$refs.view.update()"></code-transfer>
		</module>
	</page>
</template>

<script>
import saasDeposit from '@/mixins/saas_deposit';

    import handoverReject from '@/mixins/handover_reject';
	import {mapState, mapGetters} from 'vuex'
	import codeTransfer from "@/pages/storage/code_transfer.vue";

	export default {
        mixins: [saasDeposit, handoverReject],
        handoverModuleType: 3,
		components: {codeTransfer},

		computed: {
			...mapState(['saleOverallStateDic', 'productStateDic', 'userInfo', 'saasInfo']),
			/*********版本能力开关（登录时由服务端下发）：门店版无接驳与调拨，本页顶部批量调拨/返库按钮不露（行级按钮可见性改由服务端 data.buttons 下发）**********/
			...mapGetters(['hasHandover']),
			/*********是否销售中（state==32 或 main_state==4 时展示主状态 overall_state）**********/
			isOnSale() {
				return (data) => data && (data.state == 32 && data.overall_state != 5);
			},
			/*********演示机是否可操作（已放开接驳人本人限制，仅按总体状态判定；服务端写接口仍校接驳状态门）**********/
			canEditDemo() {
				return (data) => !!(data && (data.overall_state == 1 || data.overall_state == 3));
			},
			/*********是否存在可上架渠道（未上架过/已下架；在售、已售出、同步中不可再上架，与上架弹框数据范围一致）**********/
			hasShelfableChannel() {
				return (data) => {
					if (!data || !data.channel_list || !data.channel_list.length) return true;
					return data.channel_list.some(channel => channel.sync_state != 2 && [1, 3].includes(channel.listing_state));
				};
			},
			/*********是否存在可下架渠道（在售排除同步中；暗拍待推送取消，与下架弹框数据范围一致）**********/
			hasOffShelfableChannel() {
				return (data) => {
					if (!data || !data.channel_list) return false;
					return data.channel_list.some(channel => {
						if (channel.sync_state == 2) return false;
						/**暗拍在售即已进入竞拍，不可手动下架（与后端 hasOffShelfableChannel 一致）*/
						if (channel.is_dark_auction == 1 && channel.listing_state == 2) return false;
						return channel.listing_state == 2 || (channel.is_dark_auction == 1 && channel.sync_state == 1);
					});
				};
			},
			/*********渠道是否可改价（改价范围：仅发布成功的渠道可改价；靓机在售与已下架可改、暗拍待推送可改；同步中/待下架/未发布不可改）**********/
			canEditPrice() {
				return (channel) => {
					if (!channel) return false;
					/**未发布成功的渠道一律不展示改价入口（含首次发布失败、运营端废除发布身份等）*/
					if (channel.channel_publish_state != 2) return false;
					/**暗拍在售即已进入竞拍，不可改价（与后端 checkPriceAdjustState 一致）*/
					if (channel.is_dark_auction == 1 && channel.listing_state == 2) return false;
					/**暗拍待推送可改价（仅 updateChannelSalePrice 改价不动同步不发MQ）*/
					if (channel.is_dark_auction == 1 && channel.sync_state == 1) return true;
					/**同步中不可改价（避免与推送任务冲突）*/
					if (channel.sync_state == 2) return false;
					/**待下架任务不可改价*/
					if (channel.sync_state == 1 && channel.sync_type == 3) return false;
					/**靓机（非暗拍）在售(2)与已下架(3)均可改价：待上架/已售出/锁定中不可（与后端 checkPriceAdjustState 同口径）*/
					if (channel.listing_state != 2 && channel.listing_state != 3) return false;
					return true;
				};
			}
		},

		data() {
			return {
				levelTypeOptions: [],
				qualityCheckOptions: [{
					name: '是',
					value: 1
				}, {
					name: '否',
					value: 2
				}],
				priceRatio: null,
				/**低于控价的处置方式（1-严格拦截 2-仅提醒），与服务端 sale_price_control_mode 同一取值*/
				controlMode: 2,
				/*********库龄颜色配置（图例与列表分色同源驱动）**********/
				stockAgeColors: [
					{min: 1, max: 7, color: '#333', label: '1-7天'},
					{min: 8, max: 15, color: '#2b7be4', label: '8-15天'},
					{min: 16, max: 30, color: '#cc00ff', label: '16-30天'},
					{min: 31, max: 60, color: '#ff9900', label: '30天-60天'},
					{min: 61, max: null, color: '#ed3f14', label: '60天以上'}
				],
                categoryId:0,
                brandId:0
			}
		},

		mounted() {
			this.loadLevelOptions();
			this.loadPriceRatio();
		},

		methods: {
			/*********演示机开关（state 为切换前是否处于[1]=是；确认后置为 2-否 / 1-是）**********/
			demoHandle(state, next, data) {
				this.request({
					url: '/sale/product/edit/demo',
					data: {
						product_id: data.id,
						is_demo: state ? 2 : 1
					},
					success: (data, message) => {
						this.$message({message: message, type: 'success'});
						next();
					}
				});
			},

			/*********发起调拨（销售中→质检/维修，支持扫码补充）：仅待上架/已下架可调拨，已上架在售需先下架**********/
			openTransfer(data) {
                if (!data  || !data.length) {
                    this.$message({message: '请选择要调拨的记录', type: 'warning'});
                    return;
                }
                var list = Array.isArray(data) ? data : [data];
                var validList = list.filter(item => [1, 3].includes(item.overall_state));
                if (!validList.length) {
                    this.$message({message: '请勾选【待上架/已下架】状态的商品，已上架商品需先下架再调拨', type: 'warn'});
                    return;
                }
                if (validList.length < list.length) {
                    this.$message({message: '已过滤 ' + (list.length - validList.length) + ' 件不可调拨商品（已上架在售需先下架）', type: 'warn'});
                }
				this.$refs.codeTransfer.open(validList);
			},

			/*********加载等级选项**********/
			loadLevelOptions() {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LEVEL_TYPE'
					},
					success: data => {
						this.levelTypeOptions = data;
					}
				});
			},

			/*********加载控价设置（比例与处置方式同源一次回传）**********/
			loadPriceRatio() {
				this.request({
					url: '/sale/product/priceRatio/get',
					success: data => {
						if (data) {
							this.priceRatio = data.price_ratio === undefined ? null : data.price_ratio;
							this.controlMode = data.control_mode || 2;
						}
					}
				});
			},

			/*********编辑控价设置（独立入口，非导入改价）**********/
			editPriceRatio() {
				this.globalDialog('salePriceRatio', {
					data: {
						price_ratio: this.priceRatio,
						control_mode: this.controlMode
					}
				}, () => {
					this.loadPriceRatio();
					/**控价比例变更会改变每行最低控价，不刷新列表则标签与控价展示与后端不一致*/
					this.$refs.view.update();
				});
			},

			/*********服务端是否下发了最低控价（未维护控价比例时无此字段）**********/
			hasMinPrice(data) {
				return !!data && data.min_price !== null && data.min_price !== undefined && data.min_price !== '' && !isNaN(parseFloat(data.min_price));
			},

			/*********渠道售价是否低于最低控价**********/
			isBelowMinPrice(data, price) {
				if (!this.hasMinPrice(data)) return false;
				var salePrice = parseFloat(price);
				if (!(salePrice > 0)) return false;
				return salePrice < parseFloat(data.min_price);
			},

			/*********搜索产品分类**********/
			searchCategory(keyword, resolve) {
				this.request({
					url: '/spu/category/options',
					data: {keyword},
					success: data => {
						resolve(data);
					}
				});
			},

			/*********搜索品牌**********/
			searchBrand(keyword, resolve) {
				this.request({
					url: '/spu/brand/options',
					data: {
						category_id: this.categoryId,
						keyword
					},
					success: data => {
						resolve(data);
					}
				});
			},

            /*******搜索机型****************/
            searchModel(keyword, resolve) {
                this.request({
                    url: '/spu/model/options',
                    data: {
                        category_id: this.categoryId,
                        brand_id: this.brandId,
                        keyword: keyword
                    },
                    success: data => {
                        resolve(data);
                    }
                })
            },

			/*********搜索推送渠道**********/
            searchChannel(keyword, resolve) {
                this.request({
                    url: '/sale/product/channel/options',
                    data: {
                        keyword: keyword
                    },
                    success: data => {
                        resolve((data || []).map(item => {
                            return {
                                name: item.channel_name,
                                value: item.channel_id
                            };
                        }));
                    }
                });
            },

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********格式化天数**********/
			formatDay(day) {
				if (day === null || day === undefined || day === '') return '-';
				return parseInt(day) + '天';
			},

			/*********库龄分档颜色（按stockAgeColors配置匹配区间）**********/
			stockAgeColor(day) {
				if (day === null || day === undefined || day === '') return '';
				var age = parseInt(day);
				if (isNaN(age)) return '';
				for (var i = 0; i < this.stockAgeColors.length; i++) {
					var item = this.stockAgeColors[i];
					if (age >= item.min && (item.max === null || age <= item.max)) return item.color;
				}
				return '';
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********获取成色列表（成色按参考渠道展示）**********/
			getConditionList(data) {
				var list = [];
				if (data.condition_list && data.condition_list.length) {
					data.condition_list.forEach(item => {
						if (item.channel_name && item.level_name) {
							list.push(item.channel_name + '：' + item.level_name);
						}
					});
				}
				return list.length ? list : ['-'];
			},

			/*********渠道状态展示（基于 sync_state + sync_type + listing_state）**********/
			channelStateText(channel) {
				const ss = channel.sync_state;
				const st = channel.sync_type;
				const ls = channel.listing_state;
				const opName = {1: '发布', 2: '上架', 3: '下架', 4: '调价', 5: '信息更新', 6: '售出下架', 7: '锁单下架', 8: '退货退款恢复'}[st] || '操作';
				/**业务终态优先于传输进度态：已售出/下单锁定是订单在本渠道落定的事实态，不被 sync 进度（待推送/推送中/推送失败）盖过；
				 * 否则 listing_state=4/5 会落到下面 listingText 的 || '-' 显示为空杠*/
				if (ls === 4) {
					return { text: '已售出', tip: '', cls: 'm-state-on' };
				}
				if (ls === 5) {
					return { text: '锁定中', tip: '', cls: 'm-state-syncing' };
				}
                if (ss === 1) {
                    /**本地已下架且待推送的是下架类任务（售出/锁单/手动下架已先行置 listing_state=3）：如实展示已下架，不再误显「待推送」；
                     * 上架任务(st=2)除外——重新上架曾取消的暗拍待推送时 listing_state 仍停在 3（渠道侧真实态），此时应如实展示待推送*/
                    if (ls === 3 && st !== 2) {
                        return { text: '已下架', tip: '', cls: 'm-state-default' };
                    }
                    return { text: '待推送', tip: '', cls: '' };
				}
				if (ss === 2) {
					/**需审批渠道（转转严选）发布受理后停在同步中，后端将审核过程状态写入 sync_fail_reason（进入同步中时已清空旧值，非空即审核中），
					 * 界面直接展示「上架中，需质检」，后端原始进展说明收在悬浮；无说明则回落通用「推送中」*/
					if (channel.sync_fail_reason) {
						return { text: '上架中，需质检', tip: channel.sync_fail_reason, cls: 'm-state-syncing' };
					}
					return { text: '推送中', tip: '正在' + opName, cls: 'm-state-syncing' };
				}
				if (ss === 4) {
					return { text: '推送失败', tip: opName + '失败：' + (channel.sync_fail_reason || ''), cls: 'm-state-fail' };
				}
				const listingText = {1: '待上架', 2: '已上架', 3: '已下架'}[ls] || '-';
				const listingCls = ls === 2 ? 'm-state-on' : 'm-state-default';
				/**在售、已售出不算「不能上架」（在售本就在架），只有待上架/已下架需要解释为什么批量上架不放行**/
				const shelfTip = (ls === 1 || ls === 3) ? this.channelShelfWarn(channel) : '';
				return { text: listingText, tip: shelfTip, cls: listingCls };
			},

			/*********渠道不能上架的原因（对齐后端 batchOnShelf 的可上架判据，返回空表示无阻碍）**********
			 * 这两条是列表上唯一看不出、又直接决定批量上架放行与否的信息，故挂 ! 悬浮说明；
			 * 报告未发布、暗拍互斥需查库判定，不在此预判，由提交后的后端提示给数*/
			channelShelfWarn(channel) {
				if (channel.channel_publish_state && channel.channel_publish_state != 2) return '商品未发布';
				if (!(channel.sale_price > 0)) return '该渠道未设置售价';
				return '';
			},

			/*********质检报告状态样式（0不展示，1待发布橙色，2已发布绿色，3已下架红色）**********/
			qualityReportClass(val) {
				return {1: 'm-quality-pending', 2: 'm-quality-published', 3: 'm-quality-offshelf'}[val] || '';
			},

			/*********上架（单条走原上架弹框，可发布商品与填价；多条走批量上架，仅对已发布渠道切上架状态）**********/
			shelfProduct() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (!selected.length) {
					this.$message({message: '请勾选要上架的商品', type: 'warn'});
					return;
				}
				if (selected.length == 1) {
					var row = selected[0];
					/**可上架渠道范围全由服务端判定下发（含商户已授权但商品尚未关联的渠道），端内不再自算渠道状态：
					 * 只翻已有的渠道关联行会把「只上了一个渠道且在售、还能上别的渠道」误判成无可上架渠道，与行级上架按钮同源*/
					var shelfBtn = row.buttons && row.buttons.shelf;
					if (shelfBtn && !shelfBtn.visible) {
						this.$message({message: shelfBtn.reason || '该商品当前不可上架', type: 'warn'});
						return;
					}
					this.openShelfChannel(row);
					return;
				}
				/**批量只做已发布渠道的状态切换；不在此拦截也不裁剪勾选范围，
				 * 能否上架逐个渠道在弹框内给原因，最终可上架的商品与渠道组合由后端过滤**/
				this.batchShelf(selected);
			},

			/*********打开上架渠道弹框**********/
			openShelfChannel(data) {
				this.checkDepositBefore(() => {
					this.globalDialog('saleShelfChannel', {
						data: data
					}, () => {
						this.$refs.view.update();
					});
				});
			},

			/*********批量上架（仅渠道上架，勾选渠道后由后端过滤可上架的商品与渠道组合）**********/
			batchShelf(list) {
				this.checkDepositBefore(() => {
					this.globalDialog('saleBatchShelfChannel', {
						data: {
							list: list
						}
					}, () => {
						this.$refs.view.update();
					});
				});
			},

			/*********下架（行内/批量：弹框勾选可下架渠道）**********/
			batchOffShelf() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				var validList = selected.filter(item => this.hasOffShelfableChannel(item));
				if (!validList.length) {
					this.$message({message: '请勾选存在可下架渠道的商品', type: 'warn'});
					return;
				}
				this.offShelf(validList);
			},

			offShelf(list) {
				if (!list || !list.length) return;
				this.globalDialog('saleOffShelfChannel', {
					data: {
						list: list
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********单条调拨（行级）：按钮可见性已由服务端按状态判定，点开即为合法行，直接打开调拨弹框**********/
			rowTransfer(data) {
				if (!data) return;
				this.$refs.codeTransfer.open([data]);
			},

			/*********线下售出快捷入口（行级单条 / 顶部批量共用）：弹框内走与手工扫码相同的后端校验，不在此处预判商品状态**********/
			offlineSell(data) {
				var target = (data && data.length) ? data : this.$refs.view.$refs.list.getData('selected');
				if (!target || !target.length) {
					this.$message({message: '请勾选要售出的商品', type: 'warn'});
					return;
				}
				var codes = target.map(item => item.produce_unique_code).filter(code => code);
				if (!codes.length) {
					this.$message({message: '所选商品缺少背贴码，无法开单', type: 'warn'});
					return;
				}
				this.checkDepositBefore(() => {
					this.globalDialog('offlineOrderEdit', {
						data: {codes: codes}
					}, () => {
						this.$refs.view.update();
					});
				});
			},

			/*********借出快捷入口（行级单条 / 顶部批量共用）：弹框内走与手工扫码相同的后端校验，不在此处预判商品状态**********/
			lendOut(data) {
				var target = (data && data.length) ? data : this.$refs.view.$refs.list.getData('selected');
				if (!target || !target.length) {
					this.$message({message: '请勾选要借出的商品', type: 'warn'});
					return;
				}
				var codes = target.map(item => item.produce_unique_code).filter(code => code);
				if (!codes.length) {
					this.$message({message: '所选商品缺少背贴码，无法借出', type: 'warn'});
					return;
				}
				this.globalDialog('saleLendEdit', {
					data: {codes: codes}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********返库（行级单条 / 批量共用）：单条直接传入选中行，顶部批量按钮不传参时回退取表格勾选**********/
			batchReturnToStock(data) {
				var target = (data && data.length) ? data : this.$refs.view.$refs.list.getData('selected');
				var validList = (target || []).filter(item => [1, 2, 3].includes(item.overall_state));
				if (!validList.length) {
					this.$message({message: '请勾选【待上架/已上架/已下架】状态的商品', type: 'warn'});
					return;
				}
				this.$confirm({
					message: validList.length === 1
						? '确认将该商品返库吗？返库后所有渠道将下架'
						: '确认将所选的' + validList.length + '个商品返库吗？返库后所有渠道将下架',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/product/batchReturnStock',
							data: {
								product_ids: validList.map(item => item.id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********改价**********/
			editPrice() {
				this.checkDepositBefore(() => {
					this.globalDialog('salePriceEdit', {
						data: {
							view_id: this.$refs.view.getViewId()
						}
					}, () => {
						this.$refs.view.update();
					});
				});
			},

			/*********渠道改价（单商品+指定渠道，打开改价弹框单品模式）**********/
			editChannelPrice(data, channel) {
				this.checkDepositBefore(() => {
					this.globalDialog('salePriceEdit', {
						data: {
							product: data,
							channel: channel
						}
					}, () => {
						this.$refs.view.update();
					});
				});
			},

			/*********导入改价（通用导入框架 work_type=304，模板/错误报告由框架统一处理）**********/
			importPrice() {
				this.checkDepositBefore(() => {
					this.globalDialog('excelImport', {
						props: {
							workType: 304
						}
					}, () => {
						this.$refs.view.update();
						this.loadPriceRatio();
					});
				});
			},

			/*********改价记录**********/
			viewPriceLog(data) {
				this.globalDialog('salePriceLog', {data});
			},

			/*********推送记录**********/
			viewPushLog(data) {
				this.globalDialog('saleProductPushLog', {data});
			},

			/*********借出记录**********/
			viewLendLog(data) {
				this.globalDialog('saleLendLog', {data});
			},

			/*********质检报告**********/
			viewQualityReport(data) {
				this.globalDialog('qualityReportView', {
					data: {
						product_code_id: data.produce_unique_code_id,
						produce_unique_code: data.produce_unique_code,
						product_info: data.product_info
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-ratio-tip {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		margin-left: 8px;
		font-size: 13px;
		color: #666;

		i {
			cursor: pointer;
			color: #2b7be4;
		}
	}

	.m-age-legend {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		margin-left: 8px;
		font-size: 13px;
		color: #666;
	}

	.m-legend-help {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		border: 1px solid #c0c4cc;
		border-radius: 50%;
		font-size: 11px;
		color: #909399;
		cursor: pointer;
	}

	.m-legend-item {
		display: flex;
		align-items: center;
		gap: 6px;
		line-height: 22px;
		white-space: nowrap;

		.m-legend-block {
			width: 12px;
			height: 12px;
			flex-shrink: 0;
		}
	}

	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}

	.m-tag {
		display: inline-block;
		padding: 0 6px;
		height: 18px;
		line-height: 18px;
		font-size: 12px;
		border-radius: 2px;
		color: #fff;
		background: #2b7be4;

		&.m-tag-good {
			background: #19be6b;
		}
		&.m-tag-fair {
			background: #ff9900;
		}
		&.m-tag-bad {
			background: #ed3f14;
		}
	}

	.m-condition {
		line-height: 20px;
		font-size: 13px;
		color: #333;
	}

	.m-price-info {
		line-height: 20px;
		font-size: 13px;
		color: #333;
	}

	.m-quality-pending {
		color: #e6a23c;
		font-size: 20px;
		font-weight: bold;
	}
	.m-quality-published {
		color: #19be6b;
		font-size: 20px;
		font-weight: bold;
	}
	.m-quality-offshelf {
		color: #ed3f14;
		font-size: 20px;
		font-weight: bold;
	}

	.m-channel-lines {
		p {
			display: flex;
			align-items: center;
			gap: 8px;
			line-height: 20px;
			white-space: nowrap;
		}

		.m-channel-edit {
			color: #2b7be4;
			font-size: 14px;
			cursor: pointer;
		}
		.m-state-on {
			color: #19be6b;
		}
		.m-state-syncing {
			color: #e6a23c;
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.m-state-fail {
			color: #999;
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}
		.m-state-default {
			color: #999;
		}
		.m-channel-info {
			color: #ed3f14;
			font-size: 14px;
			cursor: pointer;
			margin-left: 2px;
		}
        .m-channel-tip {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 16px;
			height: 16px;
			border: 1.5px solid #ed3f14;
			border-radius: 50%;
			color: #ed3f14;
			font-size: 12px;
			font-weight: bold;
			margin-left: 4px;
			cursor: pointer;
			line-height: 1;
		}
        .red {
            color: red;
            font-weight: bold;
        }
	}

	.m-dismantle-tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		border: 1.5px solid #ed3f14;
		border-radius: 50%;
		color: #ed3f14;
		font-size: 13px;
		font-weight: bold;
	}
</style>
